// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2XNAXuEZ-7zY","filters":"_3HM1GUdeG4Fd"};